(function($) {
  if (!$) {
    return;
  }

  $(function() {
    var $form = $('.desk--version .header-search-form');
    var $input = $form.find('.header-search-input');
    var $results = $form.find('.search-suggestions');
    var request = null;
    var timer = null;
    var selectedIndex = -1;
    var routesRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    var $backdrop = $('<div class="search-suggestions-backdrop"></div>');

    if (!$form.length || !$input.length || !$results.length) {
      return;
    }

    $results.appendTo('body');
    $backdrop.appendTo('body');

    function escapeHtml(value) {
      return String(value || '').replace(/[&<>"']/g, function(character) {
        return {
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#39;'
        }[character];
      });
    }

    function searchUrl(query) {
      return routesRoot + 'search?type=product&q=*' + encodeURIComponent(query) + '*';
    }

    function productImage(product) {
      if (product && product.featured_image && product.featured_image.url) {
        return product.featured_image.url;
      }
      if (product && product.image) {
        return product.image;
      }
      return '';
    }

    function formatPrice(product) {
      if (!product || product.price === undefined || product.price === null || product.price === '') {
        return '';
      }

      var price = parseFloat(product.price);
      if (isNaN(price)) {
        return '';
      }

      return '$ ' + price.toFixed(2);
    }

    function getSuggestionItems() {
      return $results.find('a.search-suggestions__item, a.search-suggestions__view-all');
    }

    function positionResults() {
      var inputOffset = $input.offset();
      $results.css({
        left: 0,
        right: 0,
        top: inputOffset.top + $input.outerHeight() + 8,
        width: $(window).width()
      });
    }

    function setSelected(index) {
      var $items = getSuggestionItems();
      $items.removeClass('is-selected');
      selectedIndex = index;

      if (selectedIndex >= 0 && selectedIndex < $items.length) {
        $items.eq(selectedIndex).addClass('is-selected');
      }
    }

    function openResults(html) {
      $results.html(html).addClass('is-active');
      $backdrop.addClass('is-active');
      positionResults();
      $input.attr('aria-expanded', 'true');
      setSelected(-1);
    }

    function closeResults() {
      $results.removeClass('is-active').empty();
      $backdrop.removeClass('is-active');
      $input.attr('aria-expanded', 'false');
      selectedIndex = -1;
    }

    function renderProducts(products) {
      var html = '';
      if (products.length) {
        html += '<div class="search-suggestions__heading">Products</div>';
        html += '<div class="search-suggestions__products">';
      }

      $.each(products, function(index, product) {
        var image = productImage(product);
        html += '<a class="search-suggestions__item search-suggestions__product" role="option" href="' + escapeHtml(product.url) + '">';
        html += '<span class="search-suggestions__image-wrap">';
        if (image) {
          html += '<img class="search-suggestions__image" src="' + escapeHtml(image) + '" alt="">';
        }
        html += '</span>';
        html += '<span class="search-suggestions__title">' + escapeHtml(product.title) + '</span>';
        if (product.vendor) {
          html += '<span class="search-suggestions__meta">' + escapeHtml(product.vendor) + '</span>';
        }
        if (formatPrice(product)) {
          html += '<span class="search-suggestions__price">' + escapeHtml(formatPrice(product)) + '</span>';
        }
        html += '</a>';
      });

      if (products.length) {
        html += '</div>';
      }
      return html;
    }

    function renderSimpleGroup(title, items, useText) {
      var html = '';
      if (items.length) {
        html += '<div class="search-suggestions__heading">' + title + '</div>';
      }

      $.each(items, function(index, item) {
        var label = useText ? item.text : item.title;
        var url = item.url || searchUrl(label);
        html += '<a class="search-suggestions__item" role="option" href="' + escapeHtml(url) + '">' + escapeHtml(label) + '</a>';
      });
      return html;
    }

    function renderSuggestions(data, query) {
      var results = data && data.resources && data.resources.results ? data.resources.results : {};
      var products = results.products || [];
      var collections = results.collections || [];
      var queries = results.queries || [];
      var pages = results.pages || [];
      var sidebar = '';
      var main = '';
      var html = '';

      sidebar += renderSimpleGroup('Suggestions', queries.slice(0, 5), true);
      sidebar += renderSimpleGroup('Categories', collections.slice(0, 5), false);
      sidebar += renderSimpleGroup('Pages', pages.slice(0, 4), false);
      main += renderProducts(products.slice(0, 6));

      if (!sidebar && !main) {
        main = '<div class="search-suggestions__empty">No suggestions found</div>';
      }

      html += '<div class="search-suggestions__inner">';
      html += '<div class="search-suggestions__side">' + sidebar + '</div>';
      html += '<div class="search-suggestions__main">' + main + '</div>';
      html += '</div>';
      html += '<a class="search-suggestions__view-all" role="option" href="' + escapeHtml(searchUrl(query)) + '">Search for "' + escapeHtml(query) + '"<span aria-hidden="true">→</span></a>';
      openResults(html);
    }

    function loadSuggestions(query) {
      if (request && request.readyState !== 4) {
        request.abort();
      }

      request = $.ajax({
        url: routesRoot + 'search/suggest.json',
        dataType: 'json',
        data: {
          q: query,
          'resources[type]': 'product,collection,page,query',
          'resources[limit]': 6,
          'resources[limit_scope]': 'each',
          'resources[options][unavailable_products]': 'last',
          'resources[options][fields]': 'title,product_type,variants.title,variants.sku,vendor'
        }
      }).done(function(data) {
        renderSuggestions(data, query);
      }).fail(function(xhr, status) {
        if (status !== 'abort') {
          closeResults();
        }
      });
    }

    $input.on('keyup focus', function(event) {
      var ignoredKeys = [13, 27, 37, 38, 39, 40];
      var query = $.trim($input.val());

      if ($.inArray(event.which, ignoredKeys) !== -1) {
        return;
      }

      clearTimeout(timer);

      if (query.length < 2) {
        closeResults();
        return;
      }

      timer = setTimeout(function() {
        loadSuggestions(query);
      }, 250);
    });

    $input.on('keydown', function(event) {
      var $items = getSuggestionItems();

      if (!$results.hasClass('is-active') || !$items.length) {
        return;
      }

      if (event.which === 40) {
        event.preventDefault();
        setSelected(selectedIndex >= $items.length - 1 ? 0 : selectedIndex + 1);
      }

      if (event.which === 38) {
        event.preventDefault();
        setSelected(selectedIndex <= 0 ? $items.length - 1 : selectedIndex - 1);
      }

      if (event.which === 13 && selectedIndex >= 0) {
        event.preventDefault();
        window.location.href = $items.eq(selectedIndex).attr('href');
      }

      if (event.which === 27) {
        closeResults();
      }
    });

    $(document).on('click', function(event) {
      if (!$(event.target).closest('.desk--version .header-search-form, #HeaderSearchSuggestions').length) {
        closeResults();
      }
    });

    $backdrop.on('click', closeResults);

    $(window).on('resize scroll', function() {
      if ($results.hasClass('is-active')) {
        positionResults();
      }
    });
  });
})(window.jQuery);
